// MMIT API
export const API_PARAM = {
    atopicDermatitis: {
        derivedFieldId: 656,
        indication: {
            id: 287,
            name: "Uncontrolled Moderate-to-Severe Atopic Dermatitis"
        }
    },
    asthma: {
        derivedFieldId: 1189,
        indication: {
            id: 322,
            name: "Moderate-to-Severe Eosinophilic Phenotype or Oral Corticosteroid Dependent Asthma"
        }
    },
    nasalPolyposis: {
        indication: {
            id: 406,
            name: "Inadequately Controlled Chronic Rhinosinusitis with Nasal Polyps"
        }
    },
    eosinophilicEsophagitis: {
        indication: {
            id: 569,
            name: "Eosinophilic Esophagitis"
        }
    },
    prurigoNodularis: {
        indication: {
            id: 617,
            name: "Prurigo Nodularis"
        }
    },
    projectId: 933,
    url: "https://api.mmitnetwork.com",
    token: ""
    // token: added later
};
